var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_866_14844)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.26904 2.54468H17.0738V15.3101H1.26904V2.54468Z",
    stroke: "#323232",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.26904 4.08252L8.38728 10.0896C8.60663 10.2747 8.88441 10.3763 9.17144 10.3763C9.45848 10.3763 9.73626 10.2747 9.9556 10.0896L17.0738 4.08252",
    stroke: "#323232",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_866_14844"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.0206,
    height: 17.0206,
    fill: "white",
    transform: "translate(0.661133 0.416992)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.648bc2f820306afc8920b39794bf6986.svg";
export { ForwardRef as ReactComponent };